var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoNotDisturbBlue50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0007 44.7918C14.0871 44.7918 5.20898 35.9137 5.20898 25.0002C5.20898 14.0866 14.0871 5.2085 25.0007 5.2085C35.9142 5.2085 44.7923 14.0866 44.7923 25.0002C44.7923 35.9137 35.9142 44.7918 25.0007 44.7918Z",
    fill: "#1565C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 21.875H35.4173V28.125H14.584V21.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoNotDisturbBlue50);
export default __webpack_public_path__ + "static/media/icons8-do-not-disturb-blue-50.3f156cc514b9faa9015f39ae25de25f7.svg";
export { ForwardRef as ReactComponent };